<template>
  <v-row justify="center">
    <v-col md="8" lg="6" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm" v-model="valid">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <h2>{{ $t("admin.events.settings.content.title") }}</h2>
            </v-card-title>
            <v-btn @click="edit()" class="ma-4" color="primary" v-if="view">
              {{ $t("admin.events.settings.content.edit") }}
            </v-btn>
          </div>
          <v-card-text>
            <v-text-field
              maxlength="255,"
              :label="$t('admin.events.settings.content.eventsName')"
              :rules="[$v.required()]"
              required
              v-model="event.name"
              :disabled="view"
            ></v-text-field>
            <v-subheader v-if="event.brandingLogoUrl" class="pl-0">{{
              $t("admin.events.settings.content.logo")
            }}</v-subheader>
            <v-img
              v-if="event.brandingLogoUrl"
              :src="event.brandingLogoUrl || ''"
              contain
              max-width="300px"
              max-height="200px"
            >
              <v-btn
                @click="event.brandingLogoUrl = null"
                class="float-right ma-1"
                color="error"
                x-small
                v-if="event.brandingLogoUrl && editOn"
                fab
              >
                <v-icon dark>mdi-delete-forever</v-icon></v-btn
              >
            </v-img>
            <v-file-input
              :label="$t('admin.events.settings.content.logo')"
              v-show="!event.brandingLogoUrl"
              prepend-icon="mdi-image-outline"
              accept="image/*"
              v-model="fileTeaser"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" v-if="!view" color="primary" type="submit">
              {{ $t("admin.events.settings.content.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "settings.content",
  data() {
    return {
      view: true,
      editOn: false,
      event: {},
      valid: false,
      fileTeaser: null,
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    async getDataFromApi() {
      this.loading = true;
      this.event = await axios.get(`/admin/events/${this.$route.params.eventId}`);
      this.loading = false;
    },
    async save() {
      this.view = true;
      this.editOn = false;

      if (this.fileTeaser) {
        var formDataLogo = new FormData();
        formDataLogo.append("file", this.fileTeaser);
        const axiosResponse = await axios.post("/files", formDataLogo, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.event.brandingLogoUrl = axiosResponse.serveURL;
      }

      await axios.put(`/admin/events/${this.$route.params.eventId}`, this.event);

      this.$store.commit("SUCCESS", this.$t("admin.events.settings.content.msgSaved"));
      location.reload();
    },
    edit() {
      this.view = false;
      this.editOn = true;
    },
  },
};
</script>

<style scoped></style>
